import { Injectable, inject } from "@angular/core";
import { MenuOptionService } from "@app/core/services/menu-option.service";
import { MENU_OPTIONS } from "@app/shared/constants/menu-options.constants";
import { PdfMessage } from "@app/shared/models/message.model";
import { MessageService } from "@app/core/services/message.service";
import { UserSettingsService } from "@app/core/services/user-settings.service";
import { ExternalWindowHandlerService } from "@app/core/services/external-window-handler.service";
import { ExternalWindowEventTypes } from "@app/shared/models/external-window-handler.model";
import { AppInjector } from "@app/core/functions/app-injector";

@Injectable({
  providedIn: "root"
})
export class PdfViewerService {
  private menuOptionService = inject(MenuOptionService);
  private messageService = inject(MessageService);
  private userSettings = inject(UserSettingsService);

  /**
   * Open the selected PDF
   * Change the tab data to the latest URL
   *
   * @param pdfMessage : data to be sent to viewerp
   * @param forceTab : open tab regardless of viewer setting
   */
  openPdf(pdfMessage: PdfMessage, forceTab?: boolean) {
    if (!this.userSettings.viewerSettings.viewDocumentInWindow || forceTab) {
      this._openTab(pdfMessage);
    } else {
      this._openWindow(pdfMessage);
    }
  }

  get windowHandlerService(): ExternalWindowHandlerService {
    return AppInjector.get(ExternalWindowHandlerService);
  }

  /**
   * Open PDF-Viewer in tab
   * @param pdfMessage
   */
  private _openTab(pdfMessage: PdfMessage) {
    import("@shared/components/pdf-viewer/pdf-viewer/pdf-viewer.component").then(({ PdfViewerComponent }) => {
      this.menuOptionService.openMenuOption(MENU_OPTIONS.PDF_VIEWER, PdfViewerComponent, pdfMessage);

      if (this.menuOptionService.tabService.pdfTab) {
        this.messageService.sendOpenNewPdfDocumentMessage(pdfMessage);
      }
    });
  }

  /**
   * Open PDF-viewer in extenral window
   * @param pdfMessage
   */
  private _openWindow(pdfMessage: PdfMessage) {
    this.windowHandlerService.openExternalWindow(pdfMessage, ExternalWindowEventTypes.Init);
  }
}
